module.exports = __webpack_public_path__ + "img/switchPerson.b056fd7f.png";